<template>
    <div v-show="isHidden"></div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const parentModuleName = 'Product';
const { mapGetters, mapActions } = createNamespacedHelpers(parentModuleName);
export default {
    name: 'ViewStatistics',
    data() {
        return {
            isHidden: true
        };
    },
    created() {
        const product = this.getProduct();
        const id = product && product.id ? product.id : null;
        if (id) {
            if (this.$localStorage.last_viewed_products_list.products) {
                let lastViewedProducts = this.$localStorage.last_viewed_products_list.products;
                lastViewedProducts[id] = {
                    date: parseInt(Date.now() / 1000),
                    synced: false
                };
                this.syncLastViewedProducts(lastViewedProducts).then(result => {
                    let data = {};
                    if (result && result.success === true && Object.keys(result.products).length > 0) {
                        data.products = result.products;
                    } else {
                        data.products = {};
                    }
                    this.$localStorage.set('last_viewed_products_list', data);
                });
            }
            this.updateProductViewStatistics(id);
        }
    },
    methods: {
        ...mapGetters(['getProduct']),
        ...mapActions(['syncLastViewedProducts', 'updateProductViewStatistics'])
    }
};
</script>
